import React, { useEffect, useRef, useState } from "react";
import { showNotification } from "../../../components/Notification/ToastifyNotifications";

const GoogleMapComponent = ({ address, apiKey }) => {
    const mapRef = useRef(null);
    const [coordinates, setCoordinates] = useState(null);
    const [isScriptLoaded, setIsScriptLoaded] = useState(false);

    useEffect(() => {
        if (!address || !apiKey) return;

        const loadGoogleMaps = () => {
            if (document.querySelector("script[src*='maps.googleapis.com']")) {
                setIsScriptLoaded(true);
                return;
            }

            const script = document.createElement("script");
            script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
            script.async = true;
            script.defer = true;
            script.onload = () => {
                setIsScriptLoaded(true);
                fetchCoordinates();
            };
            script.onerror = () => showNotification("Failed to load Google Maps", "error");

            document.body.appendChild(script);
        };

        const fetchCoordinates = () => {
            fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${apiKey}`)
                .then((res) => res.json())
                .then((data) => {
                    if (data.status === "OK" && data.results.length > 0) {
                        setCoordinates(data.results[0].geometry.location);
                    } else {
                        showNotification("Address not found", "error");
                    }
                })
                .catch(() => showNotification("Failed to fetch coordinates", "error"));
        };

        loadGoogleMaps();
    }, [address, apiKey]);

    useEffect(() => {
        if (!coordinates || !isScriptLoaded || !mapRef.current || !window.google || !window.google.maps) {
            return;
        }

        const map = new window.google.maps.Map(mapRef.current, {
            center: coordinates,
            zoom: 15,
        });

        new window.google.maps.Marker({
            position: coordinates,
            map: map,
        });
    }, [coordinates, isScriptLoaded]);

    return (
        <div>
            <div ref={mapRef} style={{ width: "100%", height: "300px" }} />
            {!coordinates && <p>Loading map...</p>}
        </div>
    );
};

export default GoogleMapComponent;
